export default __webpack_public_path__ + "static/media/poster28.fa1ed52a.png";